import * as Yup from 'yup'
import { Audience, AudienceListParams, AudienceListRequest } from './types'

export enum AUDIENCE_FORM_FIELDS {
  ID = 'id',
  NAME = 'name',
  DESCRIPTION = 'description',
  COUNTRY = 'country',
  PROVINCES = 'state',
  DISTRICT = 'district',
  SUB_DISTRICT = 'taluka',
  CROPS = 'crop',
  PINCODE = 'pinCode',
  ACTIVE = 'active'
}

export interface IAudienceForm {
  [AUDIENCE_FORM_FIELDS.ID]: number;
  [AUDIENCE_FORM_FIELDS.NAME]: string;
  [AUDIENCE_FORM_FIELDS.DESCRIPTION]: string;
  [AUDIENCE_FORM_FIELDS.COUNTRY]: number;
  [AUDIENCE_FORM_FIELDS.PROVINCES]: number;
  [AUDIENCE_FORM_FIELDS.DISTRICT]: number;
  [AUDIENCE_FORM_FIELDS.SUB_DISTRICT]: number;
  [AUDIENCE_FORM_FIELDS.PINCODE]: number;
  [AUDIENCE_FORM_FIELDS.CROPS]: number;
  [AUDIENCE_FORM_FIELDS.ACTIVE]: boolean;
}

export const audienceFormLabels: Record<string, string> = {
  [AUDIENCE_FORM_FIELDS.ID]: 'ID',
  [AUDIENCE_FORM_FIELDS.NAME]: 'Name',
  [AUDIENCE_FORM_FIELDS.DESCRIPTION]: 'Description',
  [AUDIENCE_FORM_FIELDS.COUNTRY]: 'Country',
  [AUDIENCE_FORM_FIELDS.PROVINCES]: 'State',
  [AUDIENCE_FORM_FIELDS.DISTRICT]: 'District',
  [AUDIENCE_FORM_FIELDS.SUB_DISTRICT]: 'Sub District',
  [AUDIENCE_FORM_FIELDS.CROPS]: 'Crop',
  [AUDIENCE_FORM_FIELDS.PINCODE]: 'Pincode',
  [AUDIENCE_FORM_FIELDS.ACTIVE]: 'Active'
}

export const defaultAudienceFormValues: IAudienceForm = {
  [AUDIENCE_FORM_FIELDS.ID]: 0,
  [AUDIENCE_FORM_FIELDS.NAME]: '',
  [AUDIENCE_FORM_FIELDS.DESCRIPTION]: '',
  [AUDIENCE_FORM_FIELDS.COUNTRY]: 0,
  [AUDIENCE_FORM_FIELDS.PROVINCES]: 0,
  [AUDIENCE_FORM_FIELDS.DISTRICT]: 0,
  [AUDIENCE_FORM_FIELDS.SUB_DISTRICT]: 0,
  [AUDIENCE_FORM_FIELDS.CROPS]: 0,
  [AUDIENCE_FORM_FIELDS.PINCODE]: 0,
  [AUDIENCE_FORM_FIELDS.ACTIVE]: true
}

export const mapAudienceToFormValues = (
  audienceData?: Audience | null
): IAudienceForm => {
  return audienceData
    ? {
        [AUDIENCE_FORM_FIELDS.ID]: audienceData.id || 0,
        [AUDIENCE_FORM_FIELDS.NAME]: audienceData.name || '',
        [AUDIENCE_FORM_FIELDS.DESCRIPTION]: audienceData.description || '',
        [AUDIENCE_FORM_FIELDS.COUNTRY]: audienceData.country?.id || 0,
        [AUDIENCE_FORM_FIELDS.PROVINCES]: audienceData.state?.id || 0,
        [AUDIENCE_FORM_FIELDS.DISTRICT]: audienceData.district?.id || 0,
        [AUDIENCE_FORM_FIELDS.SUB_DISTRICT]: audienceData.taluka?.id || 0,
        [AUDIENCE_FORM_FIELDS.CROPS]: audienceData.crop?.id || 0,
        [AUDIENCE_FORM_FIELDS.PINCODE]: audienceData.pinCode || 0,
        [AUDIENCE_FORM_FIELDS.ACTIVE]: audienceData.active ?? true
      }
    : defaultAudienceFormValues
}

export const audienceValidationSchema = Yup.object({
  [AUDIENCE_FORM_FIELDS.NAME]: Yup.string()
    .required(' Audience Name is required')
    .min(3, 'Name must be at least 3 characters')
    .max(30, 'Name must be at most 30 characters'),

  [AUDIENCE_FORM_FIELDS.DESCRIPTION]: Yup.string()
    .required('Description is required')
    .max(255, 'Description must be at most 255 characters'),

  [AUDIENCE_FORM_FIELDS.COUNTRY]: Yup.number()
    .required('Country is required')
    .moreThan(0, 'Country is required')
})

export const getPaginationQueryParams = (
  request: AudienceListRequest
): AudienceListParams => {
  const { filters, page } = request
  const params: AudienceListParams = {
    size: page?.size,
    page: page?.number ? page.number - 1 : 0
  }
  if (filters && filters.length > 0) {
    filters.forEach(({ fieldName, fieldValue }) => {
      if (
        fieldValue === null ||
        fieldValue === undefined ||
        fieldValue === '' ||
        fieldValue === 'all'
      ) {
        delete params[fieldName]
      } else {
        params[fieldName] = fieldValue
      }
    })
  }

  return params
}
